export const shipList = [
  {
    name: '海洋光谱号',
    code: 'gp',
    icon: 'ship_gp',
    value: 'SC'
  },
  // {
  //   name: '海洋赞礼号',
  //   code: 'zl',
  //   icon: 'ship_zl',
  //   value: 'OV'
  // }
  // , {
  //   name: '海洋量子号',
  //   code: 'lz',
  //   icon: 'ship_lz',
  //   value: 'QN'
  // }, {
  //   name: '海洋航行者号',
  //   code: 'hxz',
  //   icon: 'ship_hxz',
  //   value: 'VY'
  // }
]

export const serviceMenu = [
  {
    name: '超凡网络',
    value: 'Wifi',
    icon: '0',
    code: 'wifi',
    bookingIndex: 0 // 活动预订页面菜单顺序
  }, {
    name: '超凡娱乐',
    value: 'entertainment',
    icon: '1',
    code: 'entertainment',
    bookingIndex: 1
  }, {
    name: '超凡餐饮',
    value: 'dining',
    icon: '2',
    code: 'food',
    bookingIndex: 2
  }, {
    name: '超凡服务',
    value: 'service',
    icon: '3',
    code: 'service',
    bookingIndex: 4
  }, {
    name: '超凡观光',
    value: 'pcpShorex',
    icon: '4',
    bookingIndex: 3
  }, {
    name: '行前订商城',
    value: 'hjsc',
    icon: '5',
    bookingIndex: '5'
  }
]

export const footerMenu = [
  {
    title: '用户指南',
    url: '/page_beginners_tips'
  }, {
    title: '常见问题',
    url: '/page_question'
  }, {
    title: '服务条款',
    url: '/terms'
  }, 
  // {
  //   title: '新闻中心',
  //   url: '/page_news_list'
  // }
]

export const baseNav = [
  {
    title: '首页',
    icon: 'home',
    url: '/',
    urlNew: '/Rccl.Pcp/Home/Index'
  },
  {
    title: '购物车',
    icon: 'goods_cart',
    url: '/page_shopping_cart',
    urlNew: '/Rccl.PCP/order/ShoppingCart'
  },
  {
    title: '意向单',
    icon: 'intention',
    url: 'shoppingcart'
  },
  {
    title: '我的',
    icon: 'user',
    url: '/page_order_detail_complete',
    urlNew: '/Rccl.PCP/Order/PageAllOrderDetails'
  },
  {
    title: '航线',
    icon: 'route',
    url: '/cruise'
  }
]

// 岸上观光类型
export const shorexTypes = [
  {
    name: '精品游',
    value: 1
  }, {
    name: '常规游',
    value: 2
  }, {
    name: '私人订制游',
    value: 3
  }
]
